<template>
    <div class="modal" :class="{ 'is-active': isActive }">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-content">
            <div class="box">
                <article class="media">
                    <div class="media-content">
                        <div class="content">
                            <h3 class="title has-text-danger has-text-centered">DEPOSIT {{ username ? ' - '+username : '' }}</h3>
                            <div class="theme-table-container table-container center-column w-100">
                                <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                                    <thead>
                                        <tr>
                                            <th>Credit Info</th>
                                            <th>Date Created</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="deposit in clientDeposits">
                                            <td>Excess Payment</td>
                                            <td>{{ deposit.date }}</td>
                                            <td>{{ getCurrency }}{{ deposit.deposit | formatNumber }}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                    <tr>
                                        <th colspan="2" align="right">Total</th>
                                        <th>{{ getCurrency }}{{ totalDeposits | formatNumber }}</th>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </div>
        <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
    </div>
</template>

<script>
    export default {
        props: ['username'],
        computed: {
            isActive() {
                return this.$store.getters.getClientDepositModalStatus
            },
            clientDeposits(){
                return this.$store.getters.getClientDeposits
            },
            totalDeposits(){
                let total_deposit = 0;
                this.clientDeposits.forEach((deposit) => {
                    total_deposit += Number(deposit.deposit)
                })
                return total_deposit;
            },
            getCurrency(){
                return this.$store.getters.getCurrentUser.info.price_plan.deposit_rate == 1 ? '¥' : '$'
            }
        },
        methods: {
            closeModal () {
                this.$store.commit('setClientDepositModalStatus', false)
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Banking/ClientDepositHistoryModal.vue